<template>

    <div class="login-template forgot-password">
        <div class="left-side">
            <div class="top">
                <a href="/" class="logo">
                    <logo></logo>
                </a>
            </div>
            <div class="login-content">
                <div class="content">
                    <h1>{{ $t('login.forgot-password.headline') }}</h1>
                    <p class="intro">{{ $t('login.forgot-password.text') }}</p>
                    <form>
                        <div class="material-input">
                            <input id="email" type="email" v-model="email"
                                   class="form-control" name="email" required autofocus
                                   v-on:keyup="onKeyUpEmail" v-bind:class="{ active: isActiveEmail }"
                            >
                            <p class="label"><label for="email">
                                {{ $t('login.form.email') }}
                            </label></p>
                        </div>

                        <div class="button-container">
                            <button type="submit"
                                    :disabled="!validateInput"
                                    class="purple"
                                    @click.prevent="sendEmail"
                            >
                                {{ $t('button.login.reset-password') }}
                            </button>
                            <router-link to="/login">{{ $t('login.label.go-back') }}</router-link>
                        </div>
                    </form>

                </div>

            </div>
            <div class="bottom">
                <copyright></copyright>
                <span class="seperator">|</span>
                <a target="_blank" href="https://www.rently.dk/terms/">{{ $t('login.label.terms-conditions') }}</a>
            </div>
        </div>
        <div class="right-side">
            <div class="content">
                <div class="image">
                    <img src="/images/img/login-illustrationv2.png">
                </div>
                <div class="text">
                    <h2>{{ $t('login.teaser.line-one') }}<br>{{ $t('login.teaser.line-two') }}</h2>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import Logo from '../../components/Logo';
import Copyright from '../../components/Copyright';

export default {
    data: () => ({
        email: ''
    }),
    methods: {
        onKeyUpEmail: function () {
            this.isActiveEmail = true;
        },
        sendEmail() {

            axios({
                method: 'POST',
                url: window.config.apiUrl + 'api/password/forget',
                data: {
                    email: this.email
                }
            }).then(() => {
                this.$swal(this.$t('reset-password.sent.label'), '', 'success');
            });

        },
        validEmail(email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    },
    components: {
        Logo,
        Copyright
    },
    computed: {
        validateInput() {
            return this.validEmail(this.email);
        }
    }
}
</script>

<style scoped>

</style>
